var ele = ele || {};

/**
 * the purpose of this file is to introduce commonly used functions which are part of the JavaScript specifications
 * that aren't available in older versions of browsers (namely IE 7/8).
 * This is to minimise bugs being introduced because of unknown lack of support and generally reduce frustration
 */
   
 /** TRIM */
if (typeof String.prototype.trim !== 'function') {
    String.prototype.trim = function() {
        return this.replace(/^\s+|\s+$/g, '');
    }
}
if (typeof Date.prototype.withoutTime !== 'function') {
    Date.prototype.withoutTime = function () {
        var d = new Date(this);
        d.setHours(0, 0, 0, 0);
        return d;
    }
}


/** serialize object **/
$(function(){
	if(typeof(jQuery)!='undefined'){
		jQuery.fn.extend({
			serializeObject:function(){
				var o = {};
				var a = this.serializeArray();
				$.each(a, function() {
					if (o[this.name]) {
						if (!o[this.name].push) {
							o[this.name] = [o[this.name]];
						}
						o[this.name].push(this.value || '');
					} else {
						o[this.name] = this.value || '';
					}
				});
				return o;
			}
		});
	}
	
});

// custom event polyfill for IE 11
(function () {
  if ( typeof window.CustomEvent === "function" ) return false; //If not IE

  function CustomEvent ( event, params ) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent( 'CustomEvent' );
    evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
    return evt;
   }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
})();


//https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
if (!Array.prototype.findIndex) {
  Object.defineProperty(Array.prototype, 'findIndex', {
    value: function(predicate) {
     // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1];

      // 5. Let k be 0.
      var k = 0;

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return k.
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return k;
        }
        // e. Increase k by 1.
        k++;
      }

      // 7. Return -1.
      return -1;
    }
  });
}

//https://github.com/jsPolyfill/Array.prototype.find
Array.prototype.find = Array.prototype.find || function(callback) {
    if (this === null) {
        throw new TypeError('Array.prototype.find called on null or undefined');
    } else if (typeof callback !== 'function') {
        throw new TypeError('callback must be a function');
    }
    var list = Object(this);
    // Makes sures is always has an positive integer as length.
    var length = list.length >>> 0;
    var thisArg = arguments[1];
    for (var i = 0; i < length; i++) {
        var element = list[i];
        if ( callback.call(thisArg, element, i, list) ) {
            return element;
        }
    }
};

/** striptags **/
String.prototype.stripTags = function() {
    var container = document.createElement('div');
    container.innerHTML = this;
    return container.textContent || container.innerText;
};

/** sanitise **/
String.prototype.sanitize = function() {
    const map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#x27;',
        "/": '&#x2F;',
    };
    const reg = /[&<>"'/]/ig;
    return this.replace(reg, (match)=>(map[match]));
};

String.prototype.highlightText = function(searchString = "") {
    searchString = searchString.stripTags();
    if (searchString != "") {
        var reg = new RegExp('(' + searchString + ')', 'i');
        return this.replace(reg, '<span style="background-color:#cae3fc;">$1</span>');
    }
    return this;
};
Number.prototype.highlightText = function(searchString = "") {
    searchString = searchString.stripTags();
    if (searchString != "") {
        var reg = new RegExp('(' + searchString + ')', 'i');
        return this.toString().replace(reg, '<span style="background-color:#cae3fc;">$1</span>');
    }
    return this;
};


